const WG = window.WG;

export default WG;



// WEBPACK FOOTER //
// ./assets/js/common/modules/wg.js